import { Navigate, Route, Routes, matchPath, useLocation } from 'react-router-dom'
import { useEffect } from 'react'
import Sidebar from './app/dashboard/SidebarD'
import Dashboard from './app/dashboard/Dashboard'
import UsersTable from './app/dashboard/editUsersCrud/UsersTable'
import Nav from './design/components/CustomNav'
import AuctionList from './design/auctions/AuctionList'
import Login from './design/LoginRegister/Login'
import Cancelled from './design/components/paymentStatus/Cancelled'
import Failed from './design/components/paymentStatus/Failed'
import Success from './design/components/paymentStatus/Success'
import Home from './design/Home'
import PostDetails from './design/posts/PostDetails'
import AuctionDetails from './design/auctions/AuctionDetails'
import Register from './design/LoginRegister/Register'
import PostList from './design/posts/PostList'
import Profile from './design/Profile/Profile'
import ActivityPage from './design/ActivityPage'
import VerifyEmail from './design/LoginRegister/VerifyEmail'
import ResetPassword from './design/LoginRegister/ResetPassword'
import FavoritesPage from './design/FavoritesPage'
import { ProtectedRouteAdmin } from './app/common/ProtectedRouteAdmin'
import { ProtectedRoute } from './app/common/ProtectedRoute'
import { ProtectedRouteLogout } from './app/common/ProtectedRouteLogout'
import Services from './design/services/Services'
import { routesWithTitles } from './app/common/routeTitles'
import Faq from './design/faq/Faq'
import Impressum from './design/termsandservices/Impressum'
import Agb from './design/termsandservices/Agb'
import Datenschutzrichtlinien from './design/termsandservices/Datenschutzrichtlinien'

function Main() {
  const location = useLocation()
  const matchedRoute = routesWithTitles.find((route) => matchPath(location.pathname, route.path))

  useEffect(() => {
    document.title = matchedRoute ? matchedRoute.title : 'Home Auctions'
  }, [matchedRoute])

  return (
    <Routes>
      <Route element={<ProtectedRouteAdmin redirectPath='/' />}>
        <Route path='/dashboard/' element={<Sidebar />}>
          <Route index element={<Dashboard />} />
          <Route path='userList' element={<UsersTable />} />
        </Route>
      </Route>
      <Route path='/' element={<Nav />}>
        <Route index element={<Home />} />
        <Route path='auctions' element={<AuctionList />} />
        <Route path='posts' element={<PostList />} />
        <Route path='faq' element={<Faq />} />
        <Route path='impressum' element={<Impressum />} />
        <Route path='agb' element={<Agb />} />
        <Route path='datenschutzrichtlinien' element={<Datenschutzrichtlinien />} />
        <Route path='posts/:id' element={<PostDetails />} />
        <Route path='auctions/:id' element={<AuctionDetails />} />
        <Route path='services' element={<Services />} />
        <Route element={<ProtectedRoute redirectPath='/login' />}>
          <Route path='profile' element={<Profile />} />
          <Route path='activity/my' element={<ActivityPage />} />
          <Route path='favorites' element={<FavoritesPage />} />
        </Route>
        <Route element={<ProtectedRouteLogout redirectPath='/' />}>
          <Route path='login' element={<Login />} />
          <Route path='register' element={<Register />} />
          <Route path='account/verify-email' element={<VerifyEmail />} />
          <Route path='account/changePassword' element={<ResetPassword />} />
        </Route>
        <Route path='cancelled/:id' element={<Cancelled />} />
        <Route path='failed/:id' element={<Failed />} />
        <Route path='success/:id' element={<Success />} />
      </Route>
      {/* default redirect to home page */}
      <Route path='*' element={<Navigate to='/' />} />F
    </Routes>
  )
}

export default Main
